import React from "react";
import Button from '@mui/material/Button';
import PatientAction from "./patientActionButtons";


const CorporateDetails = () => {
    return (
        <><PatientAction />
        <form>
            <div className="Corporate-Details-info" >
                <div className="mt-3 ml-4"> <h4>Corporate Details</h4></div>
                <div className="row" style={{ marginLeft:0, marginRight: 0 }}>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Company Name</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Company Name" />
                        </div>
                    </div>
                     <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">EmpID</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="EmpID" />
                        </div>
                    </div>
                   <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Official EmailId</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Official EmailId" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Company Address</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Company Address" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Designation</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Designation" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end mr-4 mb-3">
                <Button variant="outlined">Submit</Button>
            </div>
        </form>
        </>
    );
};

export default CorporateDetails; 